// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3jDFl","log":"ModalInventoryLogs_log__2EavM","date":"ModalInventoryLogs_date__9aOVN","userName":"ModalInventoryLogs_userName__2axRp"};